import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { matchInfoData } from "../../features/matchInfo/matchInfoSlice";
import { useParams } from "react-router-dom";
import styles from "./MatchInfo.module.css";

const MatchInfo = () => {
  const { match_id } = useParams();

  const dispatch = useDispatch();
  const data = useSelector((state) => state.matchInfo.data);
  const pending = useSelector((state) => state.matchInfo.pending);
  const error = useSelector((state) => state.matchInfo.error);
  const finalData = data.data;

  useEffect(() => {
    dispatch(matchInfoData(match_id));
  }, [dispatch, match_id]);

  if (pending) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className={styles.parentContainer}>
      <div className={styles.matchInfoWrapper}>
        <h2>MATCH DETAILS</h2>

        {finalData && (
          <table>
            <tr>
              <td className={styles.rowHeading}>TOUNAMENT</td>
              <td>{finalData.series}</td>
            </tr>
            <tr>
              <td className={styles.rowHeading}>MATCH</td>
              <td>
                {finalData.team_a} vs {finalData.team_b}
              </td>
            </tr>
            <tr>
              <td className={styles.rowHeading}>Toss</td>
              <td>{finalData.toss}</td>
            </tr>
            <tr>
              <td className={styles.rowHeading}>VENUE</td>
              <td>{finalData.series}</td>
            </tr>
            <tr>
              <td className={styles.rowHeading}>UMPIRES</td>
              <td>{finalData.umpire}</td>
            </tr>
            <tr>
              <td className={styles.rowHeading}>THIRD UMPIRE</td>
              <td>{finalData.third_umpire}</td>
            </tr>
            <tr>
              <td className={styles.rowHeading}>MATCH RAFREE</td>
              <td>{finalData.referee}</td>
            </tr>
          </table>
        )}
      </div>
    </div>
  );
};

export default MatchInfo;
